import { useState} from "react";
import Footer from './Footer'
import Sidebar from "./Sidebar";
import Navbar from "./Navbar"

const Dashboard = ({sidebarLinks, children, navLinks, navBarTitle}) => {
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);  
 
  const toggleSideBar = () => setIsSideBarOpen(!isSideBarOpen);
  return (
    <>
      <Navbar toggleMenu={toggleSideBar} menuStatus={isSideBarOpen} navLinks={navLinks} title={navBarTitle} />

      <div className="flex gap-0">
     
          <Sidebar sidebarLinks={sidebarLinks} menuStatus={isSideBarOpen} toggleMenu={toggleSideBar} />
      

        <main className=" w-full mt-[50px] md:mt-[60px] min-h-[100vh] h-full md:l-0  overflow-hidden">
{ children}
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Dashboard;
